import React, { Component } from "react"
import * as styles from "./welcomeBountyContest.module.scss"
import ProgressiveImage from "react-progressive-image-loading"
import banner3bg from "../../../../assets/Home-BountyContest.png"
import banner3bgmin from "../../../../assets/Home-BountyContest.png"
import FacebookLogin from "react-facebook-login"
import GoogleLogin from "../react-google-login/google-login.js"
import WeChatBountyContest from "./wechatBountyContest"
import Popup from "reactjs-popup"

class WelcomeBountyContest extends Component {
  constructor(props) {
    super(props)

    this.state = { open: false, type: "reg" }
    this.en = this.en.bind(this)
    this.ct = this.ct.bind(this)

    this.handleWeChatReg = this.handleWeChatReg.bind(this)
    this.handleWeChatLogin = this.handleWeChatLogin.bind(this)

    this.closeModal = this.closeModal.bind(this)
    this.handleWeChatCallback = this.handleWeChatCallback.bind(this)
  }

  componentDidMount() {}

  handleWeChatCallback(event) {
    let code = event.target.getAttribute("data-code")
    this.closeModal()
    this.props.handleWeChatLogin(code, this.state.type)
  }

  closeModal() {
    this.setState({ open: false })
  }

  handleWeChatReg() {
    this.setState({ open: true, type: "reg" })
  }

  handleWeChatLogin() {
    this.setState({ open: true, type: "login" })
  }

  en() {
    return (
      <ProgressiveImage
        preview={banner3bgmin}
        src={banner3bg}
        transitionTime={500}
        transitionFunction="ease"
        render={(src, style) => (
          <div
            className={styles.carouselGraphic3}
            style={Object.assign(style, { backgroundImage: `url(${src})` })}
          >
            <div className={styles.carouselText}></div>

            <section className={styles.carouselImg}>
              <div className={styles.registerHeading}>Registration</div>

              <FacebookLogin
                appId={process.env.CT_FACEBOOK_API_ID}
                autoLoad={false}
                textButton=" Continue with Facebook"
                fields="first_name,last_name,email,name,picture"
                scope="public_profile, email"
                onClick={this.componentClicked}
                callback={this.props.responseFacebook}
                size="small"
                icon="fa fa-facebook-official"
                cssClass={styles.customfacebook}
              />

              <GoogleLogin
                clientId={process.env.CT_GOOGLE_API_ID}
                buttonText="Continue with Google"
                onSuccess={this.props.responseGoogle}
                onFailure={this.props.responseGoogle}
                cookiePolicy={"single_host_origin"}
                className={styles.customgoogle}
              />

              <WeChatBountyContest
                handleWeChatLogin={this.handleWeChatReg}
                buttonText="Continue with WeChat"
              />

              <div className={styles.loginHeading}>
                <span>Already Registered ?</span>
              </div>

              <FacebookLogin
                appId={process.env.CT_FACEBOOK_API_ID}
                autoLoad={false}
                textButton=" Login with Facebook"
                fields="first_name,last_name,email,name,picture"
                scope="public_profile, email"
                onClick={this.componentClicked}
                callback={this.props.responseFacebookLogin}
                size="small"
                icon="fa fa-facebook-official"
                cssClass={styles.customfacebook}
              />

              <GoogleLogin
                clientId={process.env.CT_GOOGLE_API_ID}
                buttonText="Log in with Google"
                onSuccess={this.props.responseGoogleLogin}
                onFailure={this.props.responseGoogleLogin}
                cookiePolicy={"single_host_origin"}
                className={styles.customgoogle}
              />

              <WeChatBountyContest
                handleWeChatLogin={this.handleWeChatLogin}
                buttonText="Log in with WeChat"
              />
              <div
                id="WeChatCallback"
                onClick={this.handleWeChatCallback}
              ></div>

              <div className={styles.errorMsg}>{this.props.errorMsg}</div>
              <div className={styles.loginHeading}></div>
            </section>

            <Popup
              className="wechat"
              open={this.state.open}
              closeOnDocumentClick
              onClose={this.closeModal}
            >
              {close => (
                <div className={styles.modal}>
                  <a className={styles.close} onClick={this.closeModal}>
                    &times;
                  </a>

                  <iframe
                    title="Wechat Frame"
                    id="wechatFrame"
                    src="https://open.weixin.qq.com/connect/qrconnect?appid=wxf083da00576ccce6&scope=snsapi_login&redirect_uri=https%3A%2F%2Fwww.ironcap.ca/ironcap-bountycontest/wechat-callback/&state=3d6be0a4035d839573b04816624a415e&login_type=jssdk&self_redirect=true"
                    scrolling="no"
                    width="300px"
                    height="400px"
                    frameBorder="0"
                  ></iframe>
                </div>
              )}
            </Popup>
          </div>
        )}
      />
    )
  }

  // end en

  // ct starts

  ct() {
    return (
      <ProgressiveImage
        preview={banner3bgmin}
        src={banner3bg}
        transitionTime={500}
        transitionFunction="ease"
        render={(src, style) => (
          <div
            className={styles.carouselGraphic3}
            style={Object.assign(style, { backgroundImage: `url(${src})` })}
          >
            <div className={styles.carouselText}></div>

            <section className={styles.carouselImg}>
              <div className={styles.registerHeading}>註冊</div>

              <FacebookLogin
                appId={process.env.CT_FACEBOOK_API_ID}
                autoLoad={false}
                textButton="繼續使用 Facebook 註冊"
                fields="first_name,last_name,email,name,picture"
                scope="public_profile, email"
                onClick={this.componentClicked}
                callback={this.props.responseFacebook}
                size="small"
                icon="fa fa-facebook-official"
                cssClass={styles.customfacebook}
              />

              <GoogleLogin
                clientId={process.env.CT_GOOGLE_API_ID}
                buttonText="繼續使用 Google 註冊"
                onSuccess={this.props.responseGoogle}
                onFailure={this.props.responseGoogle}
                cookiePolicy={"single_host_origin"}
                className={styles.customgoogle}
              />

              <WeChatBountyContest
                handleWeChatLogin={this.handleWeChatReg}
                buttonText="繼續使用微信註冊"
              />

              <div className={styles.loginHeading}>
                <span>已經註冊？</span>
              </div>

              <FacebookLogin
                appId={process.env.CT_FACEBOOK_API_ID}
                autoLoad={false}
                textButton="使用 Facebook 登錄"
                fields="first_name,last_name,email,name,picture"
                scope="public_profile, email"
                onClick={this.componentClicked}
                callback={this.props.responseFacebookLogin}
                size="small"
                icon="fa fa-facebook-official"
                cssClass={styles.customfacebook}
              />

              <GoogleLogin
                clientId={process.env.CT_GOOGLE_API_ID}
                buttonText="使用 Google 登錄"
                onSuccess={this.props.responseGoogleLogin}
                onFailure={this.props.responseGoogleLogin}
                cookiePolicy={"single_host_origin"}
                className={styles.customgoogle}
              />

              <WeChatBountyContest
                handleWeChatLogin={this.handleWeChatLogin}
                buttonText="使用微信登錄"
              />
              <div
                id="WeChatCallback"
                onClick={this.handleWeChatCallback}
              ></div>

              <div className={styles.errorMsg}>{this.props.errorMsg}</div>
              <div className={styles.loginHeading}></div>
            </section>

            <Popup
              className="wechat"
              open={this.state.open}
              closeOnDocumentClick
              onClose={this.closeModal}
            >
              {close => (
                <div className={styles.modal}>
                  <a className={styles.close} onClick={this.closeModal}>
                    &times;
                  </a>

                  <iframe
                    title="Wechat Frame"
                    id="wechatFrame"
                    src="https://open.weixin.qq.com/connect/qrconnect?appid=wxf083da00576ccce6&scope=snsapi_login&redirect_uri=https%3A%2F%2Fwww.ironcap.ca/ironcap-bountycontest/wechat-callback/&state=3d6be0a4035d839573b04816624a415e&login_type=jssdk&self_redirect=true"
                    scrolling="no"
                    width="300px"
                    height="400px"
                    frameBorder="0"
                  ></iframe>
                </div>
              )}
            </Popup>
          </div>
        )}
      />
    )
  }

  // end ct

  render() {
    if (this.props.lang === "ct") {
      return this.ct()
    }

    return this.en()
  }
}

export default WelcomeBountyContest
